import {
  Component,
  ChangeDetectionStrategy,
  HostBinding,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { MenuItem } from '../../interfaces/menu-item.interface';
import { OpenSubMenuPayload } from '../../interfaces/open-sub-menu-payload.interface';

@Component({
  selector: 'app-menu-items',
  templateUrl: './menu-items.component.html',
  styleUrls: ['./menu-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuItemsComponent {
  @HostBinding('class.main-menu__panel')
  public mainMenuClass = true;

  @Input()
  public menuItems: MenuItem[];
  @Input()
  public activeSectionId: string;

  @Output()
  public openSubMenu = new EventEmitter<OpenSubMenuPayload>();

  public onOpenSubMenu(i: number) {
    const hasSubmenu = !!this.menuItems[i].items?.length;
    this.openSubMenu.emit({ index: i, hasSubmenu });
  }
}
